import { useQuery } from "react-query";
import { QueryReturnType } from "../../services/networking.service";
import ENDPOINTS from "../../services/endPoints";

export interface CronJobFilters {
  enabled?: boolean | string;
  page?: number;
  limit?: number;
}

/**
 * List the scheduler's cron jobs.
 *
 * Response shape (camelCase after the API transformer):
 *   data.cronJobs[] : { _id, name, description, endpoint, schedule, enabled,
 *                       lastRun, lastRunStatus, lastRunMessage, nextRun,
 *                       runCount, failureCount, consecutiveFailures,
 *                       consecutiveFailureAlertThreshold, averageExecutionTime,
 *                       timeout, retryOnFailure, maxRetries, lockedAt, createdAt }
 *   data.totalPages, data.currentPage, data.total
 */
export const useGetCronJobs = (
  filters: CronJobFilters = {},
  enabled: boolean = true
): QueryReturnType<any> => {
  return useQuery<never, never, any>([ENDPOINTS.CRON_JOBS, filters], {
    enabled,
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    staleTime: 15 * 1000,
    cacheTime: 5 * 60 * 1000,
  });
};
